import noop from 'lodash/noop'
import React, { createContext, ReactElement, ReactNode, useContext } from 'react'

interface ContextState {
  openCreateOwnerModal?: () => void
  openEditOwnerModal?: (ownerId: string) => void
}

const defaultValue: ContextState = {
  openCreateOwnerModal: noop,
  openEditOwnerModal: noop,
}

const OrganizationOwnersContext = createContext(defaultValue)

interface OrganizationOwnersContextProps {
  onOpenCreateOwnerModal?: () => void
  onOpenEditOwnerModal?: (ownerId: string) => void
  children: ReactNode
}

export const OrganizationOwnersContextProvider = ({
  onOpenCreateOwnerModal,
  onOpenEditOwnerModal,
  children,
}: OrganizationOwnersContextProps): ReactElement => {
  return (
    <OrganizationOwnersContext.Provider
      value={{
        openCreateOwnerModal: onOpenCreateOwnerModal,
        openEditOwnerModal: onOpenEditOwnerModal,
      }}
    >
      {children}
    </OrganizationOwnersContext.Provider>
  )
}

export const useOrganizationOwners = () => useContext(OrganizationOwnersContext)
